import AboutHero from "../Images/about_hero.png";
import AboutHeritage from "../Images/about_heritage.png";
import HaldiaImg from "../Images/haldia_port.png";
import DhamraImg from "../Images/dhamra_port.png";
import ParadeepImg from "../Images/paradeep_port.webp";
import GopalpurImg from "../Images/gopalpur_port.png";
import VisakhapatnamImg from "../Images/visakhapatnam_port.png";
import GangavaramImg from "../Images/gangavaram_port.png";
import KakinadaImg from "../Images/kakinada_port.png";
import KrishnapatnamImg from "../Images/krishnapatnam_port.png";
import Globe from "../Images/Globe.png";
import HomeHero from "../Images/home_hero.jpg";
import HomeHeroVideo from "../Images/home_hero_video.mp4";
import HomeImage01 from "../Images/homeimage01.png";

import services01 from "../Images/services01.jpg";
import services02 from "../Images/services02.jpg";
import services03 from "../Images/services03.jpg";
import services04 from "../Images/services04.jpg";
import services05 from "../Images/services05.jpg";
import services06 from "../Images/services06.jpg";
import services07 from "../Images/services07.jpg";
import services08 from "../Images/services08.jpg";
import services09 from "../Images/services09.jpg";

export {
    AboutHero,
    AboutHeritage,
    HaldiaImg,
    DhamraImg,
    ParadeepImg,
    GopalpurImg,
    VisakhapatnamImg,
    GangavaramImg,
    KakinadaImg,
    KrishnapatnamImg,
    Globe,
    HomeHero,
    HomeHeroVideo,
    HomeImage01,
    services01,
    services02,
    services03,
    services04,
    services05,
    services06,
    services07,
    services08,
    services09,
};

// Legacy exports
export const ContactUsCover = HaldiaImg;
export const ServicesCoverImage = VisakhapatnamImg;
export const WebDesigningCoverImage = VisakhapatnamImg;
export const BusinessWebsiteCover = VisakhapatnamImg;
export const DefaultCoverImage = HomeHero;
export const ourproducts_contact = AboutHeritage;
